import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark min-h-[90vh] flex items-center py-16 sm:py-20 lg:py-28 px-5 sm:px-6 md:px-12 lg:px-24" data-id="element-29">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-20 items-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start space-y-6 sm:space-y-8" data-id="element-31">
          <h1 className="text-[34px] leading-[1.15] sm:text-[44px] sm:leading-[1.1] lg:text-[64px] font-bold text-brand-cream" data-id="element-32">
            Votre LinkedIn coûte des clients à chaque jour qui passe.
          </h1>

          <p className="text-[17px] sm:text-[20px] lg:text-[22px] text-brand-cream/85 leading-relaxed max-w-xl" data-id="element-33">
            En 3 à 5 jours, je le transforme en vitrine professionnelle qui
            inspire confiance — et convertit.
          </p>

          <div className="flex flex-col items-start space-y-4 w-full sm:w-auto pt-2 sm:pt-4" data-id="element-34">
            <a href="https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20LinkedIn%20Signature" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-gold text-brand-black font-bold text-[15px] sm:text-[16px] px-6 sm:px-8 py-4 rounded-[4px] hover:bg-white transition-colors duration-300 w-full sm:w-auto group" data-id="element-35">
              <ArrowRight className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform" data-id="element-36" />
              Parler à Rebeca sur WhatsApp
            </a>

            <div className="flex flex-col space-y-1" data-id="element-37">
              <p className="text-[13px] text-brand-gold italic" data-id="element-38">
                Réponse garantie en moins de 24h.
              </p>
              <p className="text-[13px] text-brand-cream/60" data-id="element-39">
                Disponible en français, español & English 🌐
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full aspect-square lg:aspect-[4/5] max-w-md mx-auto lg:max-w-none" data-id="element-40">
          <div className="absolute inset-0 bg-brand-gold/10 rounded-2xl -translate-x-4 translate-y-4" data-id="element-41"></div>
          <img src="https://cdn.magicpatterns.com/uploads/6fi6XHCgsiCq1i26BwEvxd/LOGO_PHOTO_REBECA.png" alt="Rebeca Oliveira - Visibilia" className="relative w-full h-full object-cover rounded-2xl shadow-2xl" data-id="element-42" />
        </motion.div>
      </div>
    </section>;
}